import axios from 'axios';
import store from '../Store/configureStore';
import { authService } from "../Services/AuthenticationService.js";
import * as AuthenticationActions from '../Actions/AuthenticationActions.js';

export default axios;

axios.interceptors.request.use((config) => 
	new Promise((resolve, reject) => {
		
		const state = store.getState();
		
		if( typeof(config.params['grant_type']) === 'undefined'){
			//console.log("interceptor prepara Token: "+state.user.access_token);
			//console.log(JSON.stringify(config));
			config.params['access_token'] = state.user.access_token;
		}else{
			//console.log("interceptor NO prepara Token: "+JSON.stringify(config));
		}
    resolve(config);
}), (error) => {
	console.log("request error: "+error);
    return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
	return response;
	}, async function (error) {
		const state = store.getState();
		let originalRequest = error.config;
		if (error.response.status === 401) {
			const response = await authService.refreshToken(state.user.refresh_token);
			//console.log("interceptor refreshToken 401");
			store.dispatch(AuthenticationActions.refreshTokenAction(response.data));
			originalRequest.params['access_token'] = response.data.access_token;
			return axios(originalRequest);
		}else if(error.response.status === 400){
			if(originalRequest && originalRequest.params && originalRequest.params['grant_type']=="refresh_token") {
				//console.log("interceptor refreshToken 400");
				store.dispatch(AuthenticationActions.logoutAction());
				return Promise.reject(error);
			}
		}
		return Promise.reject(error);
	}
);
